import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { Icon, IconifyIcon } from '@iconify/react';
import lockCheck from '@iconify/icons-mdi/lock-check';
import lockOpenVariant from '@iconify/icons-mdi/lock-open-variant';
import fileUndo from '@iconify/icons-mdi/file-undo';
import chevronDoubleLeft from '@iconify/icons-mdi/chevron-double-left';
import chevronDoubleRight from '@iconify/icons-mdi/chevron-double-right';
import chevronLeft from '@iconify/icons-mdi/chevron-left';
import chevronRight from '@iconify/icons-mdi/chevron-right';
import chevronDown from '@iconify/icons-mdi/chevron-down';
import chevronUp from '@iconify/icons-mdi/chevron-up';
import pauseIcon from '@iconify/icons-mdi/pause';
import playIcon from '@iconify/icons-mdi/play';
import replayIcon from '@iconify/icons-mdi/replay';
import checkIcon from '@iconify/icons-mdi/check';
import stopIcon from '@iconify/icons-mdi/stop';
import deleteIcon from '@iconify/icons-mdi/delete';
import undoIcon from '@iconify/icons-mdi/undo';
//import alertIcon from '@iconify/icons-mdi/alert';
import alertCircleOutline from '@iconify/icons-mdi/alert-circle-outline';
import databaseIcon from '@iconify/icons-mdi/database';
import pencilIcon from '@iconify/icons-mdi/pencil';
import toolsIcon from '@iconify/icons-mdi/tools';
import cogIcon from '@iconify/icons-mdi/cog';
import closeIcon from '@iconify/icons-mdi/close';
import catIcon from '@iconify/icons-mdi/cat';
import uploadIcon from '@iconify/icons-mdi/upload';

const StyledIcon = Styled(Icon)`
  &.spin {
    animation-name: spin;
    animation-duration: 700ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes spin {
      0% {
        transform: rotate(360deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
  }
`;

const StyledNekoIcon = props => {

  let { icon, spinning = false, className = '', ...rest } = props;

  if (!rest.width && !rest.height) {
    rest.width = rest.height = 30;
  }

  const presetIcons = {
    'lock': lockCheck,
    'lock-open': lockOpenVariant,
    'file-undo': fileUndo,
    'chevron-double-left': chevronDoubleLeft,
    'chevron-double-right': chevronDoubleRight,
    'chevron-left': chevronLeft,
    'chevron-right': chevronRight,
    'chevron-down': chevronDown,
    'chevron-up': chevronUp,
    'pause': pauseIcon,
    'play': playIcon,
    'replay': replayIcon,
    'check': checkIcon,
    'stop': stopIcon,
    'delete': deleteIcon,
    'undo': undoIcon,
    'alert': alertCircleOutline,
    'database': databaseIcon,
    'pencil': pencilIcon,
    'tools': toolsIcon,
    'cog': cogIcon,
    'close': closeIcon,
    'cat': catIcon,
    'upload': uploadIcon,
  };

  const getIcon = () => {
    if (typeof icon === 'string') {
      return presetIcons[icon] || null;
    }
    return icon;
  };

  const iconClassName = `${className}${spinning ? ' spin' : ''}`;

  return (
    <StyledIcon icon={getIcon()} className={iconClassName} {...rest} />
  );
};

const NekoIcon = (props) => {
  return (<StyledNekoIcon {...props} />);
};

NekoIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.instanceOf(IconifyIcon), PropTypes.oneOf(['lock' ,'lock-open' ,'file-undo' ,'chevron-double-left' ,'chevron-double-right' ,'chevron-left' ,'chevron-right' ,'chevron-down' ,'chevron-up' ,'pause' ,'play' ,'replay' ,'check' ,'stop' ,'delete' ,'undo' ,'alert' ,'database' ,'pencil' ,'tools' ,'cog' ,'close' ,'cat' ,'upload'])]),
  spinning: PropTypes.bool,
  className: PropTypes.string
};

NekoIcon.defaultProps = {
  icon: undefined,
  spinning: false,
  className: ''
};

export { NekoIcon };
